import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["logoutButton", "form", "modal"]

  signOut(event) {
    if (this._isTurboNativeApp) {
      event.preventDefault()
      event.stopImmediatePropagation()
      window.TurboNativeBridge.postMessage("signOut")
    } else if (this.hasLogoutButtonTarget) {
      this.logoutButtonTarget.setAttribute("data-turbo", "false")
    }
  }

  switchAccount(event) {
    if (this._isTurboNativeApp) {
      event.preventDefault()
      event.stopImmediatePropagation()
      window.TurboNativeBridge.postMessage("switchAccount", { prefix: event.params.prefix })
    }
  }

  disable2FA() {
    const button = document.getElementById("two_step_verification_submit")
    const radio = document.getElementById("two_step_verification_none")
    if (button && radio) {
      radio.checked = true
      button.disabled = false
      button.click()
    }
  }

  async refresh2FA(event) {
    event.preventDefault()
    event.stopImmediatePropagation()

    if (event.params.url) {
      try {
        const response = await fetch(event.params.url)

        if (!response.ok) {
          console.error("Blad: ", response)
          return
        }

        const contentType = response.headers.get("content-type") || ""

        if (contentType.includes("application/json")) {
          const json = await response.json()
          if (window.TurboNativeBridge) {
            window.TurboNativeBridge.postMessage(json.status, {
              message: json.message,
              eventName: event.params.event,
              twoFAMethod: event.params.method
            })
          }
        }
      } catch (error) {
        console.error("Blad: ", error)
      }
    }
  }

  edit2FA() {
    if (this.hasModalTarget) {
      this.modalTarget.dispatchEvent(new CustomEvent("modal:open"))
    }
  }

  pageReload() {
    Turbo.visit(window.location.href, { action: "replace" })
  }

  get _isTurboNativeApp() {
    return navigator.userAgent.includes("Turbo Native")
  }
}
